import { render, staticRenderFns } from "./face.vue?vue&type=template&id=236bc975&scoped=true&"
import script from "./face.vue?vue&type=script&lang=ts&"
export * from "./face.vue?vue&type=script&lang=ts&"
import style0 from "./face.vue?vue&type=style&index=0&id=236bc975&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236bc975",
  null
  
)

export default component.exports